
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as homePKOWBJSfipZgW0FT3_45BzZbvi8Rf4rlGpf4R0djyc7gIMeta } from "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/home.vue?macro=true";
import { default as newsxhkDE2KRdgVuua13fnS361LX23p8OnCLpUCB5k1V2cQMeta } from "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/news.vue?macro=true";
import { default as indexPhnYHVoz94hWB7O9FAcUhqGO8swZ3UP_45qldRuGAa0QoMeta } from "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/index.vue?macro=true";
import { default as about_45usF_WmuXouOXgeD_45wcFhyyL7NvbnpxPoqZj85WuGk8mRwMeta } from "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/about-us.vue?macro=true";
import { default as coming_45soonWrzW7BBCQ_XlGHc2FT4O_e7tMlEewyvSYfN5kL5jnooMeta } from "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/coming-soon.vue?macro=true";
import { default as dmstGiOQWgvGDLR7YFVSmIst94UnKVyq_45ubTlrAohE4ieIMeta } from "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/dms.vue?macro=true";
import { default as hzgtlW_eNxp2F9mchB3ydtlHexBPIds27XrLtJ3tzimESAMeta } from "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/hzg.vue?macro=true";
import { default as jddX5juiXj_M8WxUsL73fxmbPE8UVLi00oO8UNAZG_bi5sMeta } from "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/jdd.vue?macro=true";
import { default as jslXW8cQ_AZom3FvnCHtvKhOlErZaK0TJOC38rkQF_45EyjUMeta } from "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/jsl.vue?macro=true";
import { default as jsnDL59uuDxafzLldhJss59kISxrihj7wRtPfO40FcFckoMeta } from "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/jsn.vue?macro=true";
import { default as kldLqCGPx432E_CEhUmzy2uzsRPS4w1wufMHuls08dTsWwMeta } from "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/kld.vue?macro=true";
import { default as hghg_45oIlMUyYDYesMmNF6qsO5nwlyOPE__45kDZFx3Vk0zo4gMeta } from "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/hghg.vue?macro=true";
import { default as hgys6HoVea2Vx2_KmdCoTto48BSycoqFICGAX6vxgxcZiScMeta } from "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/hgys.vue?macro=true";
import { default as feimaIFPyyjMEpG6xShRnkU7_vnTXn_45MkKLLKQJ1wCmd3xOUMeta } from "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/feima.vue?macro=true";
import { default as indexw5_OIekJtO5ffuMuXeMtWvMdxViReLd19A_45ps7k713cMeta } from "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/contact-us/index.vue?macro=true";
import { default as one_45codea1p0RCh3mHUl1bhNE12KcPn6_45hmzoX8M_45vyKkZAMwBQMeta } from "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/one-code.vue?macro=true";
import { default as kww_45onlinez4cx96QNW8l5HvNdgg06cXIGAGC7MKzrnrj9WeyKc_cMeta } from "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/kww-online.vue?macro=true";
import { default as settlementWUhLaOLDYYCK3tdmd1nkYwnRnfxeg7DiwQmM7xIt4I4Meta } from "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/settlement.vue?macro=true";
import { default as supply_45chainujgPQwqgVv5X_7_455EBgx_45Bpw24EspclP54Ot01YkwYsMeta } from "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/supply-chain.vue?macro=true";
import { default as store_45cashiers3LYBb2kgSWZctzbaDewD9byc0pz5s1rUeH5LENem_sMeta } from "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/store-cashier.vue?macro=true";
import { default as redemption_45centerTcyGSHO1uQkMYOCCCF9kZAseknxj2UxJBtq4sxwIbu8Meta } from "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/redemption-center.vue?macro=true";
import { default as hctx_45customer_45centerrtHEWL7Ss_UfAfXU7jdXS3hgKKYSaS7ROkRdKHkEXVYMeta } from "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/hctx-customer-center.vue?macro=true";
export default [
  {
    name: "home",
    path: "/home",
    meta: homePKOWBJSfipZgW0FT3_45BzZbvi8Rf4rlGpf4R0djyc7gIMeta || {},
    component: () => import("/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/home.vue")
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/news.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexPhnYHVoz94hWB7O9FAcUhqGO8swZ3UP_45qldRuGAa0QoMeta || {},
    component: () => import("/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/index.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    meta: about_45usF_WmuXouOXgeD_45wcFhyyL7NvbnpxPoqZj85WuGk8mRwMeta || {},
    component: () => import("/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/about-us.vue")
  },
  {
    name: "coming-soon",
    path: "/coming-soon",
    meta: coming_45soonWrzW7BBCQ_XlGHc2FT4O_e7tMlEewyvSYfN5kL5jnooMeta || {},
    component: () => import("/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/coming-soon.vue")
  },
  {
    name: "products-dms",
    path: "/products/dms",
    component: () => import("/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/dms.vue")
  },
  {
    name: "products-hzg",
    path: "/products/hzg",
    component: () => import("/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/hzg.vue")
  },
  {
    name: "products-jdd",
    path: "/products/jdd",
    component: () => import("/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/jdd.vue")
  },
  {
    name: "products-jsl",
    path: "/products/jsl",
    component: () => import("/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/jsl.vue")
  },
  {
    name: "products-jsn",
    path: "/products/jsn",
    component: () => import("/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/jsn.vue")
  },
  {
    name: "products-kld",
    path: "/products/kld",
    component: () => import("/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/kld.vue")
  },
  {
    name: "products-hghg",
    path: "/products/hghg",
    component: () => import("/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/hghg.vue")
  },
  {
    name: "products-hgys",
    path: "/products/hgys",
    component: () => import("/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/hgys.vue")
  },
  {
    name: "products-feima",
    path: "/products/feima",
    component: () => import("/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/feima.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/contact-us/index.vue")
  },
  {
    name: "products-one-code",
    path: "/products/one-code",
    component: () => import("/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/one-code.vue")
  },
  {
    name: "products-kww-online",
    path: "/products/kww-online",
    component: () => import("/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/kww-online.vue")
  },
  {
    name: "products-settlement",
    path: "/products/settlement",
    component: () => import("/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/settlement.vue")
  },
  {
    name: "products-supply-chain",
    path: "/products/supply-chain",
    component: () => import("/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/supply-chain.vue")
  },
  {
    name: "products-store-cashier",
    path: "/products/store-cashier",
    component: () => import("/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/store-cashier.vue")
  },
  {
    name: "products-redemption-center",
    path: "/products/redemption-center",
    component: () => import("/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/redemption-center.vue")
  },
  {
    name: "products-hctx-customer-center",
    path: "/products/hctx-customer-center",
    component: () => import("/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/pages/products/hctx-customer-center.vue")
  }
]